import { render, staticRenderFns } from "./sdworkermatList.vue?vue&type=template&id=634ad72e&"
import script from "./sdworkermatList.vue?vue&type=script&lang=js&"
export * from "./sdworkermatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports